import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './MenuComponent.module.scss';
import classNames from "classnames";
import CreateChannelIcon from '../../assets/chat.svg';
import SettingsIcon from '../../assets/settings.svg';
import ContactsIcon from '../../assets/contacts.svg';
import FavoritesIcon from '../../assets/favorites.svg';
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { closeBar, closeMenu, setIsFavorites } from "../../store/slices/appSlice";
import { clickType } from "../../constants/constants";
import MenuChild from "./MenuChild";
import UserInfo from "./UserInfo";
import CloseMenu from "./CloseMenu";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
const MenuComponent = () => {
    const isOpen = useAppSelector(state => state.app.menu);
    const dispatch = useAppDispatch();
    const currentUser = useAppSelector(state => state.app.currentUser);
    const { t } = useTypedTranslation();
    const stopPropagation = (e) => {
        e.stopPropagation();
    };
    const toFavorites = () => {
        dispatch(setIsFavorites(true));
    };
    return (_jsxs("div", { children: [_jsx("div", { className: classNames(styles.cover, { [styles.coverShow]: isOpen.cover }), onClick: () => dispatch(closeMenu()) }), _jsxs("nav", { className: classNames(styles.appBar, { [styles.showAppBar]: isOpen.bar }), children: [_jsx(CloseMenu, {}), _jsx(UserInfo, { currentInfo: currentUser }), _jsx("div", { children: _jsxs("ul", { className: styles.list, children: [_jsxs("li", { onClick: () => dispatch(closeBar(clickType.CREATE_CHANNEL)), children: [_jsx(CreateChannelIcon, {}), _jsx("span", { children: t('createChannel') })] }), _jsxs("li", { onClick: () => dispatch(closeBar(clickType.SETTINGS)), children: [_jsx(SettingsIcon, {}), _jsx("span", { children: t('settings') })] }), _jsxs("li", { onClick: () => dispatch(closeBar(clickType.CONTACTS)), children: [_jsx(ContactsIcon, {}), _jsx("span", { children: t('contacts') })] }), _jsxs("li", { onClick: toFavorites, children: [_jsx(FavoritesIcon, {}), _jsx("span", { children: t('favorites') })] })] }) })] }), _jsx("div", { className: classNames(styles.barChild, { [styles.showBarChild]: Boolean(isOpen.menuChild) }), children: _jsx(MenuChild, {}) })] }));
};
export default MenuComponent;
